/**
 * Initial state definitions for the application
 */

import { CURRENCY_CONFIG, DEFAULT_ADDRESS, EMPTY_CALCULATION, EMPTY_PROMO_CODE } from './constants'

/**
 * Empty cart state - used when cart is cleared
 */
export const cartEmpty = {
  cartOpen: false,
  cartUpdating: false,
  checkoutOpen: false,
  promoCode: { ...EMPTY_PROMO_CODE },
  differentBillingAddress: false,
  itemsInCart: false,
  stripeOptions: false,
  cartState: {
    sectionOpen: 1,
  },
  addressRequired: true,
  shippingError: "",
  preparePayment: false,
  accordianItem: 2,
  shipping: { ...EMPTY_CALCULATION },
  discount: { ...EMPTY_CALCULATION },
  calculating: false,
  isFetchingCart: false,
  cartError: "",
  promoCodeApplied: false,
  packaging: { ...EMPTY_CALCULATION },
  packagingOptions: [],
  rates: [],
  shippingName: "",
  shippingID: "",
  packagingID: "",
  packagingName: "",
  shipping_address: { ...DEFAULT_ADDRESS },
  billing_address: {},
  cartProducts: [],
  cartTotal: {
    productQuantity: 0,
    totalPrice: 0,
    currencyId: "GBP",
    currencyFormat: "£",
  },
  totals: {
    shipping: 0,
    discount: 0,
    items: 0,
    total: 0,
  },
  payPalOrderID: "",
  orderData: {},
}

/**
 * Default application state values
 */
export const defaultValues = {
  storeInitilised: true,
  scarfOrder: {},
  links: [],
  scarves: {},
  scarfID: "",
  cart: [],
  cartUpdating: false,
  isOpen: false,
  loading: false,
  onOpen: () => {},
  onClose: () => {},
  addVariantToCart: () => {},
  removeLineItem: () => {},
  updateLineItem: () => {},
  client: null,
  checkout: {
    lineItems: [],
  },
  ss: {},
  pd: {},
  ts: {
    pc: false,
  },
  cartInitialised: false,
  runUpdateTotals: false,
  accepts_marketing: false,
  contactNumber: "",
  emailAddress: "",
  fullName: "",
  packagingID: "",
  shippingID: "",
  marketing: true,
  addressFromLink: false, // Track if address came from Link authentication
}
